var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c(_vm.layout, {
    tag: "component"
  }, [_c('router-view'), _c('CookieLaw', {
    attrs: {
      "id": "cookie-notice",
      "theme": "dark-lime"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function fn(props) {
        return _c('div', {
          staticClass: "col content"
        }, [_c('p', [_vm._v(" 🍪 Na našem spletnem mestu uporabljamo piškotke, ki so nujno potrebni za delovanje spletnega mesta in so nameščeni samodejno. ")]), _c('div', {
          staticClass: "content__actions"
        }, [_c('a', {
          staticClass: "btn btn-sm btn-outline-light",
          attrs: {
            "href": "https://brevisvelox.com/#/privacy",
            "target": "_blank"
          }
        }, [_c('span', [_vm._v("Več informacij")])]), _c('a', {
          staticClass: "btn btn-sm btn-light",
          on: {
            "click": props.accept
          }
        }, [_c('span', [_vm._v("OK")])])])]);
      }
    }])
  }, [_vm._v(" a ")])], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }